import styled from "styled-components";

import SearchForm, { SearchField } from "../../components/design/layout/search";

export const Form = styled(SearchForm)`
    flex-direction: row;
    padding-right: 0;
    padding-left: 0;
    border: 0;

    input[type=text],
    input[type=search],
    button[type=submit] {
        height: 38px
    }

    input[type=text],
    input[type=search] {
        border: 1px solid ${({ theme }) => theme.color.light};
        padding: 0 .9375rem;
        border-radius: 0.375rem;
    }

    button[type=button],
    button[type=submit] {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 92px;

        span {
            color: ${({ theme }) => theme.color.gray};
            font-size: 13px;
            display: block;
            margin-right: 5px;
            position: relative;
    top: 1px;
        }
        svg {
            path {
                fill: ${({ theme }) => theme.color.blue};
            }
        }
    }
`;

export const Field = styled(SearchField)`
    height: 34px !important;
`;

export const WrapperContent = styled.div`
    position: fixed;
    top: 58px;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: ${({theme}) => theme.zIndex.contentFixed};
    overflow: scroll;
    overscroll-behavior: contain;
    padding-bottom: 6.625rem;
    background-color: ${({ theme }) => theme.color.white};
    padding-top: 0.9375rem;
`;

export const SearchSuggestion = styled.div`
    margin-bottom: 1.5625rem;
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme.color.black};
    font-size: 15px;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    margin-bottom: 0.625rem;
`;

export const Switch = styled.div``;

export const Label = styled.label`
    background-color: ${({ theme }) => theme.color.light};
    border-radius: 0.1875rem;

    input[type=radio],
    input[type=checkbox] {
        display: none;
        visibility: hidden;
        opacity: 0;
    }

    input:checked ~ span.mark {
        background-color: ${props => props.switchButtonColor};
        color: ${({ theme }) => theme.color.white};
        font-weight: ${({ theme }) => theme.fontWeight.fw700};
    }

    &:last-child {
        margin-left: 0.625rem;
    }
`;

export const SwitchField = styled.input``;

export const Mark = styled.span`
    background-color: ${({ theme }) => theme.color.transparent};
    color: ${({ theme }) => theme.color.gray};
    font-size: 13px;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    display: block;
    padding: 8px 15px;
    border-radius: 0.1875rem;
`;

export const MostWanted = styled.div``;

export const ResultItem = styled.label`
    padding: 5px 0 5px 5px;
    margin-bottom: 0;
    display: inline-block;

    input[type=radio],
    input[type=checkbox] {
        display: none;
        visibility: hidden;
        opacity: 0;
    }

    &:first-child {
        margin-left: 0;
    }

    input:checked ~ span.mark {
        background-color: ${({ theme }) => theme.color.blue};
        color: ${({ theme }) => theme.color.white};
        font-weight: ${({ theme }) => theme.fontWeight.fw500};
    }

    .mark {
        padding: 0.3125rem 0.9375rem 0.5625rem 0.9375rem;
        background-color: ${({ theme }) => theme.color.light};
        color: ${({ theme }) => theme.color.gray};
        font-weight: ${({ theme }) => theme.fontWeight.fw500};
        text-transform: lowercase;
        line-height: 1;
        border-radius: 6.25rem;
    }
`;

export const HiddenRadioField = styled.input``;
